import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppModule as WeeklySchedulerModule } from '@captiveaire/weeklyscheduler';
import { AngularUpgradeHelper } from '@caslink/common-client/ng-app/helpers/AngularUpgradeHelper';
import { AppModule as CasCommonAppModule } from '@caslink/common-client/ng-app/module';
import { DeviceGroupingComponent } from '../device-grouping/device-grouping.component';
import { DynamicCalendarComponent } from '../dynamic-calendar/dynamic-calendar.component';
import { EmptyComponent } from '../empty-component/empty.component';
import { InputSectionComponent } from '../input-section/input-section.component';
import { RealTimeSensorInputComponent } from './real-time-sensor-input/real-time-sensor-input.component';
import { DeviceInputBaseComponent } from './device-input-base.component';
import { DeviceInputComponent } from './device-input.component';
import { DeviceInputHostDirective } from './device-input-host.directive';
import { DynamicElementListInputComponent } from './dynamic-element-list-input/dynamic-element-list-input.component';
import { FaultSensorComponent } from './fault-sensor/fault-sensor.component';
import { NumberSensorInputComponent } from './number-sensor-input/number-sensor-input.component';
import { SliderNumberSensorInputComponent } from './slider-number-sensor-input/slider-number-sensor-input.component';
import { TextNumberSensorInputComponent } from './text-number-sensor-input/text-number-sensor-input.component';
import { SecondsSensorInputComponent } from './seconds-sensor-input/seconds-sensor-input.component';
import { SelectListInputComponent } from './select-list-input/select-list-input.component';
import { StaticElementListInputComponent } from './static-element-list-input/static-element-list-input.component';
import { SwitchSensorComponent } from './switch-sensor/switch-sensor.component';
import { TimeDateSensorInputComponent } from './time-date-sensor-input/time-date-sensor-input.component';

@NgModule({
    imports: [
        CasCommonAppModule,
        CommonModule,
        FormsModule,
        MatCardModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatMomentDateModule,
        MatInputModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatTabsModule,
        MatTooltipModule,
        NgxSliderModule,
        ReactiveFormsModule,
        WeeklySchedulerModule,
        MatIconModule,
        MatButtonToggleModule,
        FlexModule
    ],
    declarations: [
        DeviceInputHostDirective,
        DeviceInputComponent,
        DeviceGroupingComponent,
        DynamicCalendarComponent,
        DynamicElementListInputComponent,
        EmptyComponent,
        InputSectionComponent,
        NumberSensorInputComponent,
        RealTimeSensorInputComponent,
        SecondsSensorInputComponent,
        SelectListInputComponent,
        SliderNumberSensorInputComponent,
        StaticElementListInputComponent,
        SwitchSensorComponent,
        TextNumberSensorInputComponent,
        TimeDateSensorInputComponent,
        FaultSensorComponent,
        DeviceInputBaseComponent
    ],
    entryComponents: [
        DeviceInputComponent,
        DeviceGroupingComponent,
        DynamicCalendarComponent,
        DynamicElementListInputComponent,
        EmptyComponent,
        InputSectionComponent,
        NumberSensorInputComponent,
        RealTimeSensorInputComponent,
        SecondsSensorInputComponent,
        SelectListInputComponent,
        SliderNumberSensorInputComponent,
        StaticElementListInputComponent,
        SwitchSensorComponent,
        TextNumberSensorInputComponent,
        TimeDateSensorInputComponent,
        FaultSensorComponent
    ],
    exports: [
        DeviceInputComponent,
        DeviceGroupingComponent,
        DynamicCalendarComponent,
        DynamicElementListInputComponent,
        EmptyComponent,
        InputSectionComponent,
        NumberSensorInputComponent,
        RealTimeSensorInputComponent,
        SecondsSensorInputComponent,
        SelectListInputComponent,
        SliderNumberSensorInputComponent,
        StaticElementListInputComponent,
        SwitchSensorComponent,
        TextNumberSensorInputComponent,
        TimeDateSensorInputComponent,
        FaultSensorComponent
    ]
})
export class DeviceInputModule {
    private deviceModuleName = 'app.areas.devices';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.deviceModuleName, [
            DeviceInputComponent,
            DeviceGroupingComponent,
            DynamicCalendarComponent,
            DynamicElementListInputComponent,
            EmptyComponent,
            InputSectionComponent,
            NumberSensorInputComponent,
            RealTimeSensorInputComponent,
            SecondsSensorInputComponent,
            SelectListInputComponent,
            SliderNumberSensorInputComponent,
            StaticElementListInputComponent,
            SwitchSensorComponent,
            TextNumberSensorInputComponent,
            TimeDateSensorInputComponent,
            FaultSensorComponent
        ]);
    }
}
